import React, { useState, useRef, useEffect } from "react";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
/** Components Import */
import Calendar from "../../Components/Calendar";
import { Button, Loading, Dialog, Radio } from "../../Components/Bootstrap";
import { Card, Stack } from "react-bootstrap";

function AdminEducation() {
  const [loading, setLoading] = useState(false);
  const [dateValue, setDateValue] = useState(new Date()); // 달력에서 선택한 날짜 저장
  const [eduList, setEduList] = useState([]); // 등록된 교육이 있는 날
  const [waitEduList, setWaitEduList] = useState([]); // 등록된 교육에 신청이 있는 날
  const [selectedEduList, setSelectedEduList] = useState([]); // 선택한 일자에 교육 신청한 인원 리스트
  const [dialogToggle, setDialogToggle] = useState(false); // 사용자 교육 리스트 목록
  const [dialogDateValue, setDialogDateValue] = useState(new Date()); // 사용자 교육 리스트 상단 년월 변수
  const [eduDetailList, setEduDitailList] = useState([]);
  const [dialogToggle1, setDialogToggle1] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const [selectedItem, setSelectedItem] = useState({}); // 승인/반려 선택한 항목

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      await SelectLogic(); // 교육이 등록된 날짜 조회
      await SelectLogic1(Commons.DateFormating(new Date(), 6)); // 선택할 일자에 등록된 교육 데이터 조회
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 교육이 등록된 날짜 조회
  const SelectLogic = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _eduList = [];
    let _waitEduList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminEducation.AdminEducation,
        { ym: _ym }
      ).then((result) => {
        let data = result.data;
        // console.log("교육이 등록된 날짜 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _eduList.push(Commons.DateFormating(data[i].edcDt, 2));
            if (Number(data[i].inYn) > 0) {
              _waitEduList.push({
                day: Commons.DateFormating(data[i].edcDt, 2),
                count: data[i].inYn,
              });
            }
          }
          setEduList(_eduList);
          setWaitEduList(_waitEduList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 선택할 일자에 등록된 교육 데이터 조회
  const SelectLogic1 = async (_ymd) => {
    setLoading(true);
    let _selectedEduList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminEducation.GetEduList,
        { ymd: _ymd }
      ).then((result) => {
        let data = result.data;
        // console.log("선택할 날짜에 등록된 교육 데이터 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setSelectedEduList([]);
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _selectedEduList.push(data[i]);
          }
          setSelectedEduList(_selectedEduList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 교육 상세 조회
  const SelectLogic2 = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _eduDetailList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminEducation.GetDetail,
        { ym: _ym }
      ).then((result) => {
        let data = result.data;
        // console.log("교육 상세 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setEduDitailList([]);
          setSelectedEduList([]);
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _eduDetailList.push(data[i]);
          }
          setEduDitailList(_eduDetailList);
          setDialogToggle(true);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 교육 승인
  const SaveLogic = async (_param) => {
    setLoading(true);

    try {
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.AdminEducation.Create,
        { ..._param, confirmYn: radioValue }
      ).then((result) => {
        let data = result.data;
        // console.log("교육 승인: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          SelectLogic(Commons.DateFormating(dateValue, 8));
          SelectLogic1(Commons.DateFormating(dateValue, 6));
          setDialogToggle(false);
          setDialogToggle1(false);
          Commons.Toast("success", "승인되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 교육 반려
  const DeleteLogic = async (_param) => {
    setLoading(true);

    try {
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.AdminEducation.Delete,
        { ..._param, confirmYn: radioValue }
      ).then((result) => {
        let data = result.data;
        // console.log("교육 반려: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          SelectLogic(Commons.DateFormating(dateValue, 8));
          SelectLogic1(Commons.DateFormating(dateValue, 6));
          setDialogToggle(false);
          setDialogToggle1(false);
          Commons.Toast("success", "반려되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Calendar
        myHolidays={eduList}
        holidays={waitEduList}
        dateState={dateValue}
        onChange={async (e) => {
          setDateValue(e);
          await SelectLogic(Commons.DateFormating(e, 8));
          await SelectLogic1(Commons.DateFormating(e, 6));
        }}
        onActiveStartDateChange={async (e) => {
          setDateValue(e);
          await SelectLogic(Commons.DateFormating(e, 8));
          await SelectLogic1(Commons.DateFormating(e, 6));
        }}
      />
      <Card className="mt-2">
        <Card.Body className="custom-table-admin-header">
          <Stack direction="horizontal">
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-128">
              교육종류
            </div>
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
              이름
            </div>
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
              사번
            </div>
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
              승인
            </div>
          </Stack>
        </Card.Body>
        <div className="custom-table-grid-datas2">
          {selectedEduList.map((item, index) => {
            return (
              <Card key={index}>
                <Card.Body className="custom-table-admin-body">
                  <Stack direction="horizontal">
                    <Button
                      style={{ width: "128px" }}
                      shape="link"
                      size="sm"
                      title={item.edcNm}
                      onClick={() => SelectLogic2()}
                    />
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      {item.userName}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      {item.erpEmpNo}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      {item.confirmYn == "0" ? (
                        <Button
                          size="sm"
                          title="승인"
                          onClick={() => {
                            setDialogToggle1(true);
                            setSelectedItem(item);
                          }}
                        />
                      ) : (
                        item.confirmYnNm
                      )}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Card>
      <Dialog
        header={false}
        fullscreen
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        sumitButton={false}
      >
        <Calendar
          navClassName="custom-react-calendar-nav"
          todayButtonYn={false}
          dateState={dialogDateValue}
          // onChange={(e) => console.log(e)}
          onActiveStartDateChange={(e) =>
            SelectLogic2(Commons.DateFormating(e, 8))
          }
        />
        <Card>
          <Card.Body className="custom-table-admin-header">
            <Stack direction="horizontal">
              <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
                일자
              </div>
              <div className="p-2 custom-table-admin-header-text custom-table-text-width-128">
                교육종류
              </div>
              <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
                승인
              </div>
              <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
                이수
              </div>
            </Stack>
          </Card.Body>
        </Card>
        <div className="custom-table-grid-datas">
          {eduDetailList.map((item, index) => {
            return (
              <Card key={index}>
                <Card.Body className="custom-table-admin-body">
                  <Stack direction="horizontal">
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      {item.dd}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-128">
                      {item.edcNm}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      {item.confirmYn == "0" ? (
                        <Button
                          size="sm"
                          title="승인"
                          onClick={() => {
                            setDialogToggle1(true);
                            setSelectedItem(item);
                          }}
                        />
                      ) : (
                        item.confirmYnNm
                      )}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      {item.confirmYnNm}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Dialog>
      <Dialog
        title="승인·반려"
        show={dialogToggle1}
        onHide={() => setDialogToggle1(false)}
        sumitButtonName="확인"
        onSumit={() => {
          if (!radioValue) {
            return Commons.Toast("error", "승인/반려를 선택해주세요.");
          } else {
            if (radioValue == "1") {
              SaveLogic(selectedItem);
            } else if (radioValue == "2") {
              DeleteLogic(selectedItem);
            }
          }
        }}
      >
        <Radio
          items={[
            { value: "1", text: "승인", style: { color: "#0d6efd" } },
            { value: "2", text: "반려", style: { color: "red" } },
          ]}
          value={radioValue}
          onChange={(e) => setRadioValue(e)}
        />
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default AdminEducation;
